<template>
  <!-- 時間外コンポーネント(子) -->
  <div id="overtime">
    <p style="margin-bottom: 3px; width: 60px; padding-top: 10px; text-align:center;">
      <span>{{ overTimeResult[index] }}</span>
      <input type="hidden" :value="overTime" />
    </p>
  </div>
</template>

<script>
import moment from "moment";
import ConstList from './../ConstList';
export default {
  name: "OverTime",
    props: {
    dailyWorkResult: {
      type: Array,
      required: true
    },
    attendance1: Array,
    workTimeUnit: Array,
    workBasic: Array,
    index: Number,
  },
computed: {
  overTimeResult() {
    return this.dailyWorkResult.map((workTime, i) => {
      if (!workTime) return null;

      const basicWork = moment.duration(this.workBasic[i], "HH:mm"); // 基本労働時間
      const actualWork = moment.duration(workTime, "HH:mm");

      const att1 = this.attendance1[i];

      // TODO:弊社は残業割り増しのみ給与反映し、基幹部分は代休によって処理するが
      // 代休制度などない場合は以下の処理が必要（設定に入れる必要あり）
      // 休日は実働すべてを残業とする
      //if (att1 === ConstList.HOLIDAY) {        
      //  return this.formatDurationToHHMM(actualWork);
      //}

      if (att1 === ConstList.HOLIDAY) {
        const minutes = actualWork.asMinutes();

        if (minutes < 240) {
          // 4時間未満 → 全部残業
          return this.formatDurationToHHMM(actualWork);

        } else if (minutes === 240) {
          // 4時間ちょうど → 半代休 + 1h(0.25割増)
          const over = moment.duration(60, "minutes");
          return this.formatDurationToHHMM(over);

        } else if (minutes > 240 && minutes < 480) {
          // 4時間超～8時間未満 → 半代休 + (勤務時間 - 4h) + 1h(0.25割増)
          const baseOver = minutes - 240;  // 超えた分
          const bonus = 60;                // 半代休分の割増
          const over = moment.duration(baseOver + bonus, "minutes");
          return this.formatDurationToHHMM(over);

        } else if (minutes === 480) {
          // 8時間ちょうど → 代休 + 2h(0.25割増)
          const over = moment.duration(120, "minutes");
          return this.formatDurationToHHMM(over);

        } else if (minutes > 480) {
          // 8時間超 → 代休 + (勤務時間 - 8h) + 2h(0.25割増)
          const baseOver = minutes - 480;
          const bonus = 120;  // 代休分の割増
          const over = moment.duration(baseOver + bonus, "minutes");
          return this.formatDurationToHHMM(over);
        }
      }

      // 残業がない場合
      const diff = actualWork.subtract(basicWork);
      if (diff.asMinutes() <= 0) {
        return "";
      }

      // 残業時間を最小単位で切り上げ
      const unit = moment.duration(this.workTimeUnit[i] ?? "00:00", "HH:mm");
      const unitMinutes = unit.asMinutes();
      const roundedMinutes = Math.ceil(diff.asMinutes() / unitMinutes) * unitMinutes;

      const rounded = moment.duration(roundedMinutes, "minutes");
      return this.formatDurationToHHMM(rounded);
    });
    }
  },
  methods: {
    formatDurationToHHMM(duration) {
      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
    }
  },
  watch: {
    dailyWorkResult: {
      immediate: true,
      handler() {
        this.$emit('updateOverTime', {
          index: this.index,
          value: this.overTimeResult[this.index]
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}
</style>
